const img1 = require("../images/slider/slide_1.png").default
const img2 = require("../images/slider/slide_2.png").default
const img3 = require("../images/slider/slide_3.png").default

const heroSliderData = [
    {
        title: "Polo azul clara",
        description: "Todos os tamanhos disponíveis para a polo azul clara. O que está esperando para comprar? O seu verdadeiro estilo está aqui!",
        img: img1,
        color: "blue",
        path: "/catalog/polo-azul-clara"
    },
    {
        title: "Polo rosa clara",
        description: "Todos os tamanhos disponíveis para a polo rosa clara. O que está esperando para comprar? O seu verdadeiro estilo está aqui!",
        img: img2,
        path: "/catalog/polo-rosa-clara",
        color: "pink"
    },
    {
        title: "Polo laranja",
        description: "Todos os tamanhos disponíveis para a polo laranja. O que está esperando para comprar? O seu verdadeiro estilo está aqui!",
        img: img3,
        path: "/catalog/polo-laranja",
        color: "brown"
    }
]

export default heroSliderData